import React, { useState } from "react";
import { t } from "i18next";
import { PageContent } from "../../../page-content/page-content";
import { useEffectAsync } from "../../../../common/hooks/use-effect-async";
import { GetReturnRequestHandler } from "../cqrs/get-return-request/get-return-request-handler";
import { BtmReturnRequest } from "../model/btm-return-request";
import { BtmRequestDetails } from "./btm-request-details";
import { useNavigate } from "react-router-dom";
import { useWarehouseContext } from "../../pallet/warehouse-context/warehouse-context-provider";
import { context } from "../../../../context/context";
import { BtmReturnRequestLoader } from "./btm-return-request-loader";

interface IBtmRequestDetailsPageProps {
    requestId?: string;
}

export const BtmRequestDetailsPage = (props: IBtmRequestDetailsPageProps) => {
    const [returnRequest, setReturnRequest] = useState<BtmReturnRequest | undefined>(undefined);

    const navigate = useNavigate();
    const { code: warehouseCode } = useWarehouseContext();

    useEffectAsync(async () => {
        setReturnRequest(await GetReturnRequestHandler(props.requestId || ""));
    }, []);

    const handleReturnRequestUpdated = (updatedRequest: BtmReturnRequest) => {
        setReturnRequest(updatedRequest);
    };

    const handleGoBack = () => {
        navigate(`/btm-returns/` +
            `${returnRequest?.isFinalized ? "finalized" : "active"}` +
            `${context.isSuperAdministrator ? `/${warehouseCode}` : ""}`);
    };

    return <PageContent title={t("components.blueBrandReturns.page.details.title")}
                        description={t("components.blueBrandReturns.page.details.description")}
                        className={"btm-returns-page"}>
        {!returnRequest ?
            <BtmReturnRequestLoader onClose={handleGoBack} /> :
            <BtmRequestDetails request={returnRequest} onRequestUpdated={handleReturnRequestUpdated}
                               onClose={handleGoBack} />}
    </PageContent>;
};
